<div class="flex flex-col justify-start items-center md:items-start mx-auto">
  <a class="flex justify-center" routerLink="/">
    <img
      src="https://static.eset.co.za/images/login/eset_logo_2x.png"
      alt="ESET"
      width="75"
      height="38"
      class="-ml-3"
    />
  </a>
  <h1 class="text-3xl max-md:text-center font-normal text-primary mt-2">{{ (routeData$ | async)?.title }}</h1>
  @if (subtitle) {
    <p
      class="text-base max-md:text-center pb-2 mt-1 mb-6 leading-tight text-pretty font-light text-grey-blue/75"
      [innerHTML]="subtitle"
    ></p>
  }
</div>
